var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Settings", {
    staticClass: "page-settings",
    attrs: {
      region: "left",
      title: _vm.resource("TemplatePageSettings_Settings_Title"),
      tooltip: _vm.tooltip
    },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function() {
          return [
            _c("settings-slider", {
              attrs: {
                label: _vm.resource("TemplateManager_Shared_Width_Label"),
                value: _vm.width,
                min: 290,
                max: 950,
                "value-suffix": "px"
              },
              on: {
                input: function($event) {
                  return _vm.$emit("change-width", $event)
                }
              }
            }),
            _vm._v(" "),
            _c("settings-media-picker", {
              staticClass: "form-group",
              attrs: {
                "media-id": _vm.mediaId,
                label: _vm.resource(
                  "TemplateManager_Shared_BackgroundMediaId_Label"
                )
              },
              on: {
                "file-picked": function($event) {
                  return _vm.setBackground($event)
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "browse-button-right",
                  fn: function() {
                    return [
                      _vm.hasImage
                        ? _c("i", {
                            staticClass:
                              "fas fa-lg fa-trash-alt mdb-icon-btn delete float-right mt-2",
                            attrs: { "aria-hidden": "true" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.promptRemoveBackground($event)
                              }
                            }
                          })
                        : _vm._e()
                    ]
                  },
                  proxy: true
                }
              ])
            }),
            _vm._v(" "),
            _vm.hasImage
              ? _c("settings-media-cropper", {
                  staticClass: "form-group",
                  attrs: {
                    label: _vm.resource(
                      "TemplateManager_Shared_OpenMediaCropper_Button_Text"
                    ),
                    "media-id": _vm.mediaId
                  },
                  on: {
                    "image-cropped": function($event) {
                      return _vm.imageCropped($event.mediaId, $event.crop)
                    }
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("settings-color-picker", {
              attrs: {
                label: _vm.resource(
                  "TemplateManager_Shared_BackgroundColor_Label"
                ),
                value: _vm.color
              },
              on: {
                input: function($event) {
                  return _vm.$emit("change-color", $event)
                }
              }
            }),
            _vm._v(" "),
            _c("settings-slider", {
              attrs: {
                label: _vm.resource("TemplatePageSettings_Margin_Label"),
                value: _vm.margin,
                min: 1,
                max: 250,
                "value-suffix": "px"
              },
              on: {
                input: function($event) {
                  return _vm.$emit("change-margin", $event)
                }
              }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }